import React, { useEffect, useState } from 'react';
import { Input, InputNumber } from 'antd';

export const DebounceInput = ({ delayTimeout = 300, onChange, inputType = 'text', ...props }) => {
  const [value, setValue] = useState();

  const onDelayChange = event => {
    const value = inputType === 'number' ? event : event.target.value;
    delayTimeout ? setValue(value) : onchange(value);
  };

  useEffect(() => {
    const timeOutId = setTimeout(() => value && onChange(value), delayTimeout);
    return () => clearTimeout(timeOutId);
  }, [value]);

  const Component = inputType === 'number' ? InputNumber : Input;

  return <Component onChange={onDelayChange} {...props} />;
};
